import { render, staticRenderFns } from "./TakipForm.vue?vue&type=template&id=1a917fb2&scoped=true"
import script from "./TakipForm.vue?vue&type=script&lang=ts"
export * from "./TakipForm.vue?vue&type=script&lang=ts"
import style0 from "./TakipForm.vue?vue&type=style&index=0&id=1a917fb2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a917fb2",
  null
  
)

export default component.exports